import { useCallback, useEffect, useState } from "react";

export function useColumnSort(sortFn: (sort: "asc" | "desc" | null) => void) {
    const [sort, setSort] = useState<"asc" | "desc" | null>(null);

    useEffect(() => {
        sortFn(sort);
    }, [sort]);

    const progressSort = useCallback(() => {
        if (sort === "asc") {
            setSort("desc");
        } else if (sort === "desc") {
            setSort(null);
        } else {
            setSort("asc");
        }
    }, [sort]);

    return { sort, setSort, progressSort };
}
